<template>

  <select-input
    :label="label"
    v-model="formData"
    value-key="value"
    label-value="label"
    :placeholder="placeholder"
    :size="size"
    :list="selectData"
    :required="required"
    :disabled="disabled"
    :no-form="noForm"
    @change="updated"
  />

</template>

<script>

import ArrayMixins from '@/mixins/ArrayMixins'

export default {
  name: 'select-org-category',

  mixins: [ArrayMixins],

  props: {

    label: {
      type: String,
      default: 'Category'
    },

    value: {
      //      type: String,
      required: true
    },

    size: {
      type: String,
      default: 'normal'
    },

    disabled: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: null
    },

    helpText: {
      type: String,
      default: null
    },

    removeTowerCo: {
      type: Boolean,
      default: true
    },

    noForm: {
      type: Boolean,
      default: false
    }
  },


  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  },

  data () {
    return {
      formData: this.value,
      selectData: this.getConfig().selects.orgCategory
    }
  },

  created () {
    if (this.removeTowerCo) {
      let ind = this.findIndex('value', 'Tower Company', this.selectData)
      this.selectData = this.arrayRemove(this.selectData, ind)
    }
  }
}
</script>



// WEBPACK FOOTER //
// SelectOrgCategory.vue?ce3f34a4